module.exports = __webpack_public_path__ + "img/con4.0d01aa73.png";